import script from "./AppTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppTooltip.vue?vue&type=script&setup=true&lang=ts"

import "./AppTooltip.vue?vue&type=style&index=0&id=0d0f4492&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d0f4492"]])

export default __exports__